<template>
  <div class="video-load-container">
    <div v-if="poster && !videoLoaded" class="video-poster">
      <img :src="poster" alt="poster">
    </div>
    <video ref="videoPlayer" loop :muted="muted" playsinline @loadeddata="handleLoadedData" @progress="handleProgress"
      @canplaythrough="handleCanPlayThrough" @loadstart="handleLoadStart">
      <source :src="url" type="video/mp4">
      Your browser does not support the video tag.
    </video>
    <div class="muted-button-wrap">
      <div class="muted-button-position" @click="() => muted = !muted">
        <custom-button :hover="true" class="muted-button">
          <svg-icon :icon-class="muted ? 'video_muted' : 'video_muted_no'"
            :class-name="muted ? 'muted-svg' : 'muted-no-svg'"></svg-icon>
        </custom-button>
      </div>
    </div>
  </div>
</template>

<script>
import customButton from "@/components/customButton";
import Bus from "@/libs/bus";
export default {
  name: "VideoLoad",
  components: { customButton },
  props: {
    url: {
      required: true,
      type: String
    },
    poster: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      videoLoaded: false,
      progress: 0,
      targetProgress: 0, // 目标进度
      muted: true
    };
  },
  mounted() { },
  methods: {
    handleLoadedData() {
      this.calculateProgress();
    },
    handleProgress() {
      this.calculateProgress();
    },
    handleCanPlayThrough() {
      this.videoLoaded = true;
      this.targetProgress = 100; // 直接设置目标进度为100%
      this.playVideo();
    },
    handleLoadStart() {
      this.progress = 0;
      this.targetProgress = 0; // 重置目标进度
      this.videoLoaded = false;
    },
    calculateProgress() {
      // 使用视频的加载情况来更新目标进度，而不是直接更新进度条
      const videoElement = this.$refs.videoPlayer;
      if (videoElement && videoElement.buffered.length > 0) {
        const bufferedEnd = videoElement.buffered.end(videoElement.buffered.length - 1);
        const duration = videoElement.duration;
        this.targetProgress = (bufferedEnd / duration) * 100;
      }
    },
    smoothProgressUpdate() {
      // 平滑更新进度条到目标进度
      if (this.progress < this.targetProgress) {
        this.progress += 1; // 每次增加1%，可以根据需要调整
        requestAnimationFrame(this.smoothProgressUpdate);
      }
      Bus.$emit("progressLoading", this.progress);
    },
    playVideo() {
      this.$refs.videoPlayer.play();
    },
  },
  watch: {
    // 监听目标进度的变化，启动平滑过渡动画
    targetProgress: {
      handler() {
        this.smoothProgressUpdate();
      },
      deep: true,
      immediate: true
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
